import { UserRoleEnum } from 'core/types/user.type';

export type MenuItem = {
  id: number;
  title: string;
  path: string;
  /** Empty means public. Otherwise the roles allowed to see the item. */
  roles: UserRoleEnum[];
};

/**
 * Single source of truth for the primary navigation.
 *
 * NavBar (desktop) and NavBarMobile both render this. They used to keep
 * private copies, which had already drifted — mobile was missing "Quản lý",
 * so an admin on a phone had no way into the admin area.
 */
export const menuData: MenuItem[] = [
  { id: 1, title: 'Trang chủ', path: '/', roles: [] },
  { id: 2, title: 'Phả đồ', path: '/pha-do', roles: [] },
  { id: 3, title: 'Lịch sử', path: '/lich-su', roles: [] },
  { id: 4, title: 'Sự kiện', path: '/su-kien', roles: [] },
  {
    id: 5,
    title: 'Quản lý',
    path: '/quan-ly/user-detail',
    roles: [
      UserRoleEnum.PeopleAdmin,
      UserRoleEnum.EditAdmin,
      UserRoleEnum.SiteAdmin,
      UserRoleEnum.SuperAdmin,
    ],
  },
];
